import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VideoType } from '@core/enums/video-type';
import { TrackingService } from '@core/services/tracking.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FeaturedVideo } from '@modules/home/models/featured-video';
import { TranslateModule } from '@ngx-translate/core';

export interface ContentBlockedDialogData {
	message: string;
	featuredVideo?: FeaturedVideo;
	slug?: string;
}

@Component({
	selector: 'kwo-content-blocked',
	templateUrl: './content-blocked.component.html',
	styleUrls: ['./content-blocked.component.scss'],
	host: { 'class': '' },
	standalone: true,
	imports: [CommonModule, FaIconComponent, MatDialogModule, TranslateModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockedComponent implements OnInit {

	private trackingService = inject(TrackingService);

	constructor(public dialogRef: MatDialogRef<ContentBlockedComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ContentBlockedDialogData,
		private router: Router) { }

	ngOnInit(): void {
		// Track that user hit the paywall
		this.trackingService.track('Paywall Shown', {
			acquisition_content_name: this.data.slug || this.data.featuredVideo?.slug,
			content_title: this.data.featuredVideo?.title
		});
	}

	watchTrailer() {
		if (!this.data.featuredVideo?.trailer) {
			return;
		}
		this.dialogRef.close();
		this.router.navigateByUrl('/player/' + this.data.featuredVideo.trailer, { state: { type: VideoType.Trailer, slug: this.data.slug, title: this.data.featuredVideo.title } });
	}

	get hasTrailer(): boolean {
		return !!this.data.featuredVideo?.trailer;
	}

	navigateSubscribe() {
		this.trackingService.setAcquisition({
			internal_acquisition_source: 'content_blocked_paywall_popup_cta',
			acquisition_content_name: this.data.slug || this.data.featuredVideo?.slug
		});

		this.trackingService.track('Paywall CTA Clicked', {
			acquisition_content_name: this.data.slug || this.data.featuredVideo?.slug,
			content_title: this.data.featuredVideo?.title
		});

		this.router.navigate(['/aanmelden']);
	}

	goToLogin() {

		this.dialogRef.close();
		this.router.navigate(['/inloggen']);
	}
}